module.exports = __webpack_public_path__ + "static/media/poker-card.f63d6a77.png";